/**
 * Compara texto de formato fixo em ASCII (data `2026-10-20`, mês `2026-10`, hora `14:30`,
 * timestamp ISO) pelo código do caractere, que é a mesma ordem do `ORDER BY` do SQLite.
 *
 * Nesses campos o `localeCompare` dá a mesma ordem e custa caro: no Hermes do Android
 * cada chamada atravessa o JNI até o ICU (`Intl.Collator`). Um ANR no boot da Home
 * (REACT-NATIVE-3G, Redmi Note 11, 19/10/2026) pegou a thread de JS dentro do
 * `Collator.compare`. Nome digitado pela pessoa (acento, maiúscula) continua com
 * `localeCompare`.
 */
export function compareIso(left: string, right: string): number {
    if (left === right) return 0;
    return left < right ? -1 : 1;
}
